module.exports = __webpack_public_path__ + "img/Conversion Rate.5d4d95ea.svg";